import { render } from "./selecttaxtype.vue?vue&type=template&id=0322152a"
import script from "./selecttaxtype.vue?vue&type=script&lang=js"
export * from "./selecttaxtype.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__